import { FC, ReactNode, useEffect, useState } from 'react';

import { TermsAndConditionsPopup } from '@/components/TermsAndConditions';

import { canUserDismissPopup, shouldShowTermsPopup, storeDismissalDate } from './utils';
import { useGetMySDKUser } from '@/hooks';

interface TermsAndConditionsWrapperProps {
  children: ReactNode;
}

export const TermsAndConditionsWrapper: FC<TermsAndConditionsWrapperProps> = ({ children }) => {
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const { data: user, isLoading, isFetched } = useGetMySDKUser();

  useEffect(() => {
    if (!isLoading && user) {
      const shouldShow = shouldShowTermsPopup(user);
      setShowTermsPopup(shouldShow);
    }
  }, [user, isLoading]);

  const handleCloseTermsPopup = () => {
    // Only allow closing if terms have been accepted
    if (user?.termsAndConditionsAcceptedAt) {
      setShowTermsPopup(false);
    }
  };

  const handleDismissPopup = () => {
    if (canUserDismissPopup(user?.createdAt)) {
      storeDismissalDate();
      setShowTermsPopup(false);
    }
  };

  // Don't render children until we know the terms status
  if (isLoading || !isFetched) {
    return null;
  }

  // If terms popup should be shown, don't render the main app
  if (showTermsPopup) {
    return (
      <TermsAndConditionsPopup
        isOpen={showTermsPopup}
        onClose={handleCloseTermsPopup}
        onDismiss={handleDismissPopup}
        userCreatedAt={user?.createdAt}
      />
    );
  }

  return <>{children}</>;
};
